import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../services/authenticationService';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';
import { DataService } from '../services/dataService';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
@Injectable()
export class LoggedInGuard implements CanActivate {
  constructor(
    private dataService: DataService,
    private authService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | UrlTree {
    if (this.authService.isAuthenticated()) return of(true);

    return this.dataService.ping().pipe(
      map(() => {
        if (!this.authService.isAuthenticated())
        {
          this.authService.logout();
          return false;
        }

        return true;
      }),
      catchError((e) => {
        this.authService.logout();
        return of(false);
      })
    );
  }
}